import Gravity from 'Gravity';

const sliderWithQuotesContent = () => {
  const module = document.querySelector('.gg-video-module')
  document
    .querySelectorAll('.gg-video-module .wp-block-statik-slider > .swiper')
    /* eslint-disable */
    .forEach((carousel) => {
      carousel.swiper.params.spaceBetween = 24;
      /* eslint-enable */
      carousel.swiper.update();
    });
};

Gravity.ready(sliderWithQuotesContent);